import React from "react";
import ReactDOM from "react-dom";
import "./ModalVote.css";
import imgThanks from "../../images/thank.png";

const ModalVote = props => {
  if (!props.isOpen) {
    return false;
  }
  return ReactDOM.createPortal(
    <div className="ModalVote__overlay">
      <div className="ModalVote">
        <div className="ModalVote__header">
          <div className="btn__close__container">
            <div onClick={props.onClose} className="btn__close"></div>
          </div>
        </div>
        <div className="ModalVote__body">
          <h1>¡Gracias por tu voto!</h1>
          <img className="body__img" src={imgThanks} alt="" />
        </div>
      </div>
    </div>,
    document.getElementById("modalVote")
  );
};

export default ModalVote;
